import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import { space as styledSpace, SpaceProps } from 'styled-system';

const PaperStyled = styled.div<{ $shadow: 0 | 1 | 2 }>`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  box-shadow: ${({ theme, $shadow }) => ($shadow === 0 ? 'none' : theme.shadows[$shadow])};
  ${styledSpace}
`;

export interface PaperProps extends SpaceProps {
  children: ReactNode;
  padding?: number | string;
  shadow?: 0 | 1 | 2;
  style?: CSSProperties;
}

export function Paper({
  children,
  padding = 16,
  shadow = 1,
  style,
  ...spaceProps
}: PaperProps) {
  return (
    <PaperStyled $shadow={shadow} p={padding} style={style} {...spaceProps}>
      {children}
    </PaperStyled>
  );
}
